import { useFlagConfigValue } from 'hooks/business/system/useFlagConfig';
import { Tooltip } from 'antd';
import styled from '@emotion/styled';
import { css } from '@emotion/css';
import { useTranslate } from '@tolgee/react';
import IdPng from '../../assets/id.png';

/* color="white" 会把白底内联到 inner/arrow（light 需要），dark 下收回 elevated 浮层表面 */
const whiteTooltipCls = css`
  [data-color-mode='dark'] & .ant-tooltip-inner,
  [data-color-mode='dark'] & .ant-tooltip-arrow-content {
    background: var(--fett-bg-elevated) !important;
  }
`;

export const Help = () => {
  const { payQrcode } = useFlagConfigValue();
  const { t } = useTranslate();

  return (
    <Tooltip
      overlayStyle={{ maxWidth: '210px' }}
      overlayClassName={whiteTooltipCls}
      color="white"
      trigger="hover"
      title={() => (
        <HelpContainer>
          <div>
            {t('market.若在使用/购买过程中遇到问题或其他需求')}
            <br />
            {t('market.可随时扫码联系我们的客户服务专家')}
          </div>
          <img src={payQrcode} alt="qrcode" />
        </HelpContainer>
      )}
    >
      <span className="cursor-help text-[--ant-primary-color]">{t('header.联系我们')}</span>
    </Tooltip>
  );
};

export const CompanyAliHelp = () => {
  const { t } = useTranslate();
  return (
    <Tooltip
      color="white"
      overlayClassName={whiteTooltipCls}
      overlayStyle={{ maxWidth: '394px' }}
      title={() => (
        <div>
          <div className="leading-[20px] text-[var(--fett-text-secondary)]">
            {t('aiorder_ali_company_tip')}
          </div>
          <div className="px-[8px] mt-[12px]">
            <img className="w-full h-auto" src={IdPng} alt="id" />
          </div>
        </div>
      )}
    >
      <span className="cursor-help text-[--ant-primary-color]">{t('aiorder_check_alipay')}</span>
    </Tooltip>
  );
};

const HelpContainer = styled.div`
  padding: 8px;
  color: var(--fett-text-primary);

  > * {
    margin-bottom: 16px;
  }
  > h3 {
    font-size: 16px;
    color: var(--fett-text-primary);
  }
  > img {
    width: 160px;
    height: 160px;
    margin: 0 auto;
    display: block;
  }
`;
